/**
 * Packing Kiosk, full screen with no app shell: the TecMi kiosk beside a pack line opens
 * /kiosk/packing?line=A. Signed in like any page; it opens on the `packaging.kiosk` tick.
 */
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { AppShellPending } from "@/components/app/route-pending";
import { useAuth } from "@/features/auth/store";
import { KioskPage } from "@/features/packaging/kiosk/kiosk-page";

const search = z.object({ line: z.string().default("A") });

export const Route = createFileRoute("/kiosk/packing")({
  validateSearch: search,
  beforeLoad: async ({ location }) => {
    const me = await useAuth.getState().bootstrap();
    if (!me)
      throw redirect({ to: "/login", search: { redirect: location.href } });
    // The kiosk is its own tick (user, 2026-11-02), as the API's kiosk reads are.
    if (!useAuth.getState().can("packaging.kiosk")) throw redirect({ to: "/" });
  },
  pendingComponent: AppShellPending,
  component: Page,
});

function Page() {
  const { line } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <KioskPage
      line={line.toUpperCase()}
      onLine={(l) => void navigate({ search: { line: l } })}
    />
  );
}
